import { useMutation } from "@apollo/client";
import { useCallback } from "react";
import { useErrorHandler } from "TranscriptsV3/hooks";
import _ from "lodash";
import { syncTranscriptStudentEntityMutation } from "../module/AcademicRecordsMutations";

const useSyncTranscriptEntity = () => {
  const onError = useErrorHandler();

  const [mutateFn] = useMutation(syncTranscriptStudentEntityMutation, {
    onError,
  });

  const syncEntity = useCallback(
    async ({ entityType, entityId, refetchQueries }) => {
      const result = await mutateFn({
        variables: {
          input: [{ entityType, entityId }],
        },
        refetchQueries,
        awaitRefetchQueries: true,
      });

      const isSuccess = _.get(
        result,
        "data.transcript.syncTranscriptStudentEntity.isSuccess",
        false
      );

      if (!isSuccess) {
        onError();
      }
    },
    [mutateFn, onError]
  );

  return { syncEntity };
};

export default useSyncTranscriptEntity;
